import React from 'react'

import Layout from '../../components/Layout'

const BeforeContract = () => {
	return (
		<Layout
			headerMode='fixed'
			title='Antes de Contratar'
			description='GAIN sabe el precio justo a través del asesoramiento de REMAX EXCELENCIA.'>
			<section className='before-contract  benefit-section fader'>
				<h2 className='benefit-section__title'>Antes de Contratar</h2>
				<div className='benefit-section__content'>
					<h3>El precio justo</h3>
					<p>GAIN sabe el precio justo a través del asesoramiento de REMAX EXCELENCIA.</p>
					<p>
						Sabemos que si pasan meses sin ocupación en el caso de las inversiones inmobiliarias
						incide negativamente sobre la renta. Buscamos, ayudar a los clientes en la toma de
						decisiones correctas que permitan optimizar la rentabilidad.
					</p>

					<h3>Selección del mejor inquilino y garante</h3>
					<p>
						La recolección y disponibilidad de información confidencial es uno de nuestros mayores
						activos para detectar inquilinos y garantes que no puedan cumplir con el contrato.
					</p>

					<h3>Análisis de ingresos y capacidad de pago</h3>
					<p>
						Controlamos la solvencia del inquilino, de su grupo familiar y de los garantes.
						Auditamos recibos de haberes, declaraciones juradas, certificaciones de ingresos, y
						demostraciones de capacidad de pago basadas en extractos bancarios y de tarjetas de
						crédito.
					</p>

					<h3>Detección de garantes falsos mediante base de datos</h3>
					<p>Para informarnos, recurrimos a Bases de Datos propias y de terceros.</p>

					<h3>Informes del registro de la propiedad inmueble</h3>
					<p>De todas las propiedades de los inquilinos y garantes:</p>

					<ul>
						<li>Pedimos Averiguación de Estado de Dominio.</li>
						<li>
							Mediante dicho informe se detectan gravámenes (hipotecas, bien de familia), embargos e
							interdicciones que pesan sobre el inmueble.
						</li>
						<li>Solicitamos Frecuencia de Informes.</li>
						<li>
							Saber cuántas veces se han pedido Averiguaciones de Dominio de una propiedad en los
							últimos dos años, permite detectar -por su reiteración- las “garantías compradas”.
						</li>
						<li>INFORMES de codeme Y OTROS ESPECIALES.</li>
						<li>
							Solicitamos Informe de CODEME y Banco Central para saber la cultura de pago del
							cliente.
						</li>
						<li>
							Chequeamos la veracidad y exactitud de los antecedentes laborales y comerciales.
						</li>
					</ul>

					<h3>Certificaciones por escribano público</h3>
					<p>Certificamos firmas de inquilinos y garantes para:</p>

					<ol type='A'>
						<li>
							Asegurar la identidad real de los firmantes requiriéndoles documentos de identidad en
							regla y su huella dactilar.
						</li>
						<li>
							Certificar las firmas y dar fecha cierta al contrato. Así se evitan, en caso de un
							improbable conflicto judicial, las conocidas maniobras utilizadas para demorar el
							rápido desalojo de los incumplidores.
						</li>
						<li>El mejor contrato de alquiler de acuerdo a la última jurisprudencia y doctrina.</li>
						<li>Realizamos el trámite de sellado de contrato cumpliendo con la ley vigente.</li>
					</ol>
				</div>
			</section>
		</Layout>
	)
}

export default BeforeContract
